module.exports = __webpack_public_path__ + "img/profSalonBat.a0bae1e8.png";